import React from 'react';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { questions } from '../../constants/questios'
import './QuestAnswer.css'
export default function ControlledAccordions() {
    const [expanded, setExpanded] = React.useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };
    const Quest = questions.map(q =>{
        return(
            <Accordion expanded={expanded === q.panel} onChange={handleChange(q.panel)} style={{border:'2px solid #d3d3d3',borderRadius:8,marginTop:10}}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                    style={{direction:'rtl'}}
                >
                    <div className="quest_title">
                        {q.quest}
                    </div>
                </AccordionSummary>
                <AccordionDetails style={{direction:'rtl'}}>
                    <p className="quest_p">
                        { q.answer }
                    </p>
                </AccordionDetails>
            </Accordion>
        );
    })

    return (
        <div className="quest__container">
            <div className="quest">
                <h1 className="heading_section fonthead">أسئلة و أجوبة</h1>
                {Quest}
            </div>
        </div>
    );
}